<template>

    <div class="error-page">
        <h2 class="headline text-yellow"> 403</h2>

        <div class="error-content" style="padding:20px 0 0 20px;">
            <h3><i class="fa fa-warning text-yellow"></i> No access.</h3>

            <p>
                You do not have access to the requested page.
                <router-link :to="{name:'dashboard'}">Return to dashboard</router-link>.
            </p>
        </div>
    </div>

</template>

<script>

export default {

    metaInfo: {
        title:'Unauthorized',
    },

    name:'ErrorsUnauthorized',

}

</script>
